import { DocumentUploadDropzone } from "@/components/shared/dropzones/document-upload-dropzone";
import { InvoiceType } from "@/lib/constants/invoiceStatus";
import { Sparkles } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

interface UploadBoxProps {
  tenantId: string;
  invoiceType: InvoiceType;
}

export function UploadBox({
  tenantId,
  invoiceType = InvoiceType.PAYABLE,
}: UploadBoxProps) {
  const { t } = useTranslation();

  return (
    <div className="h-80">
      <DocumentUploadDropzone
        tenantId={tenantId}
        clickUploadEnabled
        invoiceType={invoiceType}
      >
        <div className="w-full h-full">
          <div className="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed rounded-xl cursor-pointer bg-gray-50/80 hover:bg-gray-100/80 transition-colors duration-200 backdrop-blur-sm">
            <div className="flex flex-col items-center justify-center px-8 py-12">
              <div className="mb-6 p-4 rounded-full bg-gray-100 dark:bg-gray-800">
                <svg
                  className="w-12 h-12 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
              </div>
              <p className="mb-3 text-lg font-semibold text-gray-700 dark:text-gray-300">
                {t("transactions.upload_box.title")}
              </p>
              <p className="mb-4 text-sm text-gray-500 dark:text-gray-400 text-center max-w-sm">
                {t("transactions.upload_box.subtitle")}
              </p>
              <div className="flex items-center justify-center px-4 py-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                <p className="text-xs text-gray-500 dark:text-gray-400 font-medium">
                  <div className="flex items-center">
                    <Sparkles className="w-3 h-3 mr-1 stroke-[2]" />
                    {t("transactions.upload_box.tag")}
                  </div>
                </p>
              </div>
            </div>
          </div>
        </div>
      </DocumentUploadDropzone>
    </div>
  );
}
